module.exports = __webpack_public_path__ + "static/media/gov.af4e3e41.png";